
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  name: "Footer",
  computed: {
    ...mapGetters("app", ["isFontLoad", "isLangDetected", "lang"])
  }
})
export default class Footer extends Vue {
  currentLang: string = "";

  checkCurrentLang() {
    if (localStorage.getItem("currentLang") === "br") {
      this.currentLang = "br";
    } else this.currentLang = localStorage.getItem("currentLang");
  }

  async mounted() {
    this.checkCurrentLang();
  }

  get copyright() {
    return `© ${new Date().getFullYear()} nakarta.com`;
  }

  @Watch("lang")
  async onLangChanged() {
    this.checkCurrentLang();
  }
}
